var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{domProps:{"innerHTML":_vm._s(_vm.item.html)}}),_c('abbr',[_vm._v(_vm._s(_vm.item.description))])])}
var staticRenderFns = []

export { render, staticRenderFns }